'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeamMemberDetailController = function () {
    function TeamMemberDetailController($scope, $ionicLoading, $state, $stateParams, ApiTeam, ApiSelections) {
        _classCallCheck(this, TeamMemberDetailController);

        this.$scope = $scope;
        this.$state = $state;
        this.$ionicLoading = $ionicLoading;
        this.memberId = $stateParams.memberId;
        this.isGroupAdmin = false;
        this.ApiTeam = ApiTeam;
        this.ApiSelections = ApiSelections;
    }

    _createClass(TeamMemberDetailController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
                duration: 10000
            });

            var teamPromises = [];
            var teamMemberPromise = this.ApiTeam.getTeamMember(this.memberId).then(function (res) {
                if (typeof res != 'undefined') {
                    _this.member = res;
                }
            }).then(function () {
                _this.ApiTeam.getTeams().then(function (res) {
                    if (typeof res != 'undefined') {
                        _this.member.adminOfGroup = res.groupAdminId == _this.memberId;
                    }
                });
            });
            teamPromises.push(teamMemberPromise);

            var selectionsPromise = this.ApiSelections.getSelectionsOfUser(this.memberId).then(function (res) {
                _this.selections = res;
            });
            teamPromises.push(selectionsPromise);

            var groupAdminPromise = this.ApiTeam.isGroupAdmin().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.isGroupAdmin = res;
                }
            });
            teamPromises.push(groupAdminPromise);

            Promise.all(teamPromises).then(function (res) {
                _this.$ionicLoading.hide();
            });
        }
    }, {
        key: 'removeTeamMember',
        value: function removeTeamMember(email) {
            var _this2 = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            this.ApiTeam.removeTeamMember(email).then(function (result) {
                _this2.$ionicLoading.hide();
                _this2.$state.go('teamDetail', {}, { reload: true });
            });
        }
    }]);

    return TeamMemberDetailController;
}();

exports.default = TeamMemberDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/team/teamMemberDetail.controller.js
 **/